import React, { useState, useEffect } from 'react';
import { mapInfoData } from './mapinfojson';
import '../Styles/MapInfo.css';

export const MapInfo = ({ onContactClick }) => {
  const resortNames = Object.keys(mapInfoData);
  const [activeResort, setActiveResort] = useState('Sukhee');
  const [currentIndex, setCurrentIndex] = useState(0);

  const { title, description, buttonText, leftImage, sliderImages } = mapInfoData[activeResort];

  // Auto-slider effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % sliderImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [sliderImages]);

  const handleLeft = () => {
    setCurrentIndex((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
  };

  const handleRight = () => {
    setCurrentIndex((prev) => (prev + 1) % sliderImages.length);
  };

  const getVisibleSlides = () => {
    const visible = [];
    const n=sliderImages.length;
    for (let i = 0; i < n; i++) {
      const index = (currentIndex + i) % sliderImages.length;
      visible.push(sliderImages[index]);
    }
    return visible;
  };

  return (
    <div className='mapinfo-container'>
    <div className='mapinfo-container-box-inner'>
      <div className='mapinfo-nav-container'>
        {resortNames.map((name) => (
          <button
            key={name}
            className={name === activeResort ? 'active' : ''}
            onClick={() => {
              setActiveResort(name);
              setCurrentIndex(0);
            }}
          >
            {name}
          </button>
        ))}
      </div>

      <div className='mapinfo-main-details-container'>
        <div className='mapinfo-main-details-left'>
          <div
  className='mapinfo-main-details-left-block-image'
  style={{
    backgroundImage: `url(${leftImage})`,
    transform: activeResort === 'Shama' ? 'rotate(90deg) scale(1.3)' : 'none',
    transition: 'transform 0.4s ease',
    transformOrigin: 'center center',
  }}
></div>


          <div className='mapinfo-main-details-left-description-container'>
            <h1>{title}</h1>
            <p>{description}</p>
            <button onClick={onContactClick}>{buttonText}</button>
          </div>
        </div>

        <div className='mapinfo-center-line'></div>

        <div className='mapinfo-main-details-right'>
          <div
            className='mapinfo-main-details-right-main-img'
            style={{
              backgroundImage: `url(${sliderImages[currentIndex]})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>

          <div className='mapinfo-main-details-right-sider-box-container'>
            <button onClick={handleLeft}>{'<'}</button>
            <div className='mapinfo-main-details-right-sider-box'>
              {getVisibleSlides().map((img, idx) => {
  // Compute actual index in sliderImages[]
                    const actualIndex = (currentIndex + idx) % sliderImages.length;
                    return (
                        <div
                        key={idx}
                        className='mapinfo-main-details-right-sider-img1'
                        style={{
                            backgroundImage: `url(${img})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                        onClick={() => setCurrentIndex(actualIndex)}
                        ></div>
                    );
                    })}
            </div>
            <button onClick={handleRight}>{'>'}</button>
          </div>
        </div>
      </div>
    </div>
    </div>

  );
};
